import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faSpinner, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import styles from './ThumbnailCreationStatus.module.scss';
import { SequenceStatus } from '../../../shared/models/sequenceStatus.enum';

interface ThumbnailCreationStatusProps {
  status: SequenceStatus;
}

const ThumbnailCreationStatus: FC<ThumbnailCreationStatusProps> = ({ status }) => {
  switch (status) {
    case SequenceStatus.WaitingForMlStitching:
      return (
        <span className={styles.sequenceStatus}>
          <FontAwesomeIcon icon={faPlay} className={styles.ready} />
          Not started
        </span>
      );
    case SequenceStatus.MlStitchingInProgress:
      return (
        <span className={styles.sequenceStatus}>
          <FontAwesomeIcon icon={faSpinner} className={`${styles.inProgress} ${styles.rotate}`} />
          In Progress
        </span>
      );
    case SequenceStatus.MlStitchingCompleted:
      return (
        <span className={styles.sequenceStatus}>
          <FontAwesomeIcon icon={faCheck} className={styles.done} />
          Finished
        </span>
      );
    case SequenceStatus.MlStitchingFailed:
      return (
        <span className={styles.sequenceStatus}>
          <FontAwesomeIcon icon={faTimes} className={styles.failed} />
          Failed
        </span>
      );
    default:
      return <span />;
  }
};

export default ThumbnailCreationStatus;
